export * from './lib/shared-mat-dialog-not-found.module';
export { MatDialogNotFoundComponent } from './lib/mat-dialog-not-found/mat-dialog-not-found.component';
